<mat-chip class="cass-id-chip" ngClass="{ 'clickable': clickable }" (click)="openOrder()" title="{{ getText() }}">
	{{ getText() }}
</mat-chip>
